// extracted by mini-css-extract-plugin
export default {"list":"ProposalsByStatus_list__shshx","link":"ProposalsByStatus_link__79LPT"};